import { faTriangleExclamation } from "@jewlr/pro-regular-svg-icons/faTriangleExclamation"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { jewlr_t } from "helpers/application"

const OutOfStockBanner = () => (
  <div
    className="tablet:w-auto tablet:border-none tablet:-mb-8 tablet:mt-24 mb-10 flex w-full rounded-lg border px-20 py-16"
    style={{ background: "#fff1cc", borderColor: "#e6ce8f" }}
  >
    <FontAwesomeIcon
      className="text-18 tablet:mr-16 mr-8"
      icon={faTriangleExclamation}
    />
    <div>
      <h2 className="text-18 tracking-tigher font-bold">OUT OF STOCK</h2>
      <p className="text-14 tracking-tigher">
        One or more of the items in {jewlr_t("cart")} is no longer available.
      </p>
    </div>
  </div>
)

export default OutOfStockBanner
